import dayjs from "dayjs";
import { getYachtId } from "src/utils";

import { type IUser } from "../../components/shared/UserList/UserList.types";
import {
  type ISearchForm,
  type ISearchFormWithUndefined,
  type ISearchResult,
} from "./SearchPage.types";

export const searchInitialValues: ISearchForm = {
  sort: "desc",
  startDate: null,
  endDate: null,
  explicit: "",
  mention: "",
  opened: "",
  status: "*",
  sub: false,
  urn: "",
  ssort: null,
  sdir: null,
  type: "",
};

export const mapSearchUsers = (data: any) =>
  (data.data
    ? data.data.map((user: IUser) => {
        let value = "";
        if (user.full_name) {
          value = user.full_name;
        } else if (user.firstname && user.surname) {
          value = `${user.firstname} ${user.surname}`;
        }
        return value;
      })
    : []) as string[];

export const mapSearchResults = (data: any) =>
  (Array.isArray(data.data)
    ? data.data
    : Object.values(data.data)) as ISearchResult[];
export const getParams = ({
  sort,
  startDate,
  endDate,
  ...rest
}: ISearchFormWithUndefined) => ({
  asc: sort === "asc",
  desc: sort === "desc",
  startDate: startDate ? dayjs(startDate).format("DD/MM/YYYY") : null,
  endDate: endDate ? dayjs(endDate).format("DD/MM/YYYY") : null,
  yachtid: getYachtId(),
  ...rest,
});
